import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { getAccountDevices } from '@gpx-spa/queries';
import {
  isAssignableTrackerDevice,
  type TrackerPickerDevice,
} from '@gpx-spa/ui';

const ASSIGNABLE_TRACKER_QUERY_PARAMS = {
  subscription_status: 'active',
  device_status: 'active,provisioned',
  exclude_groups: true,
} as const;

export function useAssignableTrackers(options: {
  accountId: MaybeRefOrGetter<number | null | undefined>;
  active?: MaybeRefOrGetter<boolean>;
}) {
  const queryAccountId = computed(() => {
    const id = toValue(options.accountId);
    if (id == null || id === 0) return 0;
    if (toValue(options.active) === false) return 0;
    return id;
  });

  const queryParams = computed(() => ASSIGNABLE_TRACKER_QUERY_PARAMS);

  const { data, isLoading, isFetching, refetch } = getAccountDevices(
    queryAccountId,
    queryParams,
  );

  const assignableDevices = computed<TrackerPickerDevice[]>(() => {
    const rows = data.value ?? [];
    return rows.filter((device) => isAssignableTrackerDevice(device));
  });

  const loading = computed(() => isLoading.value);
  const refreshing = computed(() => isFetching.value && !isLoading.value);

  return {
    devices: assignableDevices,
    loading,
    refreshing,
    refresh: () => refetch(),
  };
}
